import React, { type FunctionComponent } from 'react';
import { ContentContainer } from '../../components/ContentContainer';

export const Dashboard: FunctionComponent = () => {
    return <ContentContainer headline="Dashboard" description="Welcome to Outbank"></ContentContainer>;
};
